import { motion } from 'framer-motion';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

ActivateAccountResultForm.propTypes = {
    isSuccess: PropTypes.bool,
};

function ActivateAccountResultForm({ isSuccess }) {
    const [searchParams] = useSearchParams();
    const reason = searchParams.get('reason');
    const path = window.location.pathname;
    const isMobileApp = useMemo(() => {
        return path?.includes(AppRoute.mobileApp);
    }, [path])
    const isMaintainerApp = useMemo(() => {
        return path?.includes(AppRoute.maintainerApp);
    }, [path])

    return (
        <motion.div
            className="login-form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
        >
            <div className="form fv-plugins-bootstrap fv-plugins-framework">
                <div className="pt-lg-0 text-center">
                    <h3
                        className="font-weight-boldest"
                        style={{
                            fontSize: Utils.returnFontSize(30),
                            color: isSuccess ? AppColors.primary : AppColors.danger,
                        }}
                    >
                        {isSuccess ? 'Kích hoạt thành công' : 'Không thành công'}
                    </h3>
                    <p
                        className="font-weight-bolder mb-2"
                        style={{ fontSize: Utils.returnFontSize(16), color: AppColors.gray[500] }}
                    >
                        {reason ? (
                            reason
                        ) : isSuccess ? (
                            isMobileApp ? (
                                <>
                                    Tài khoản {' '}
                                    <span style={{ color: AppColors.gray[800] }}>[Địa chỉ email tài khoản]</span>{' '}
                                    trên ứng dụng [tên ứng dụng] đã được kích hoạt thành công.
                                </>
                            ) : (
                                <>
                                    Tài khoản{' '}
                                    <span style={{ color: AppColors.gray[800] }}>[Địa chỉ email tài khoản]</span>{' '}
                                    đã được kích hoạt thành công. Vui lòng nhấn vào nút bên dưới để đến trang đăng nhập.
                                </>
                            )
                        ) : (
                            isMobileApp ? (
                                <>
                                    Rất tiếc, kích hoạt tài khoản {' '}
                                    <span style={{ color: AppColors.gray[800] }}>[Địa chỉ email tài khoản]</span>{' '}
                                    trên ứng dụng [tên ứng dụng] không thành công. Vui lòng thử lại.
                                </>
                            ) : (
                                <>
                                    Rất tiếc, kích hoạt tài khoản{' '}
                                    <span style={{ color: AppColors.gray[800] }}>[Địa chỉ email tài khoản]</span>{' '}
                                    không thành công. Vui lòng thử lại.
                                </>
                            )
                        )}
                    </p>
                </div>

                {isSuccess && (
                    <div className="form-group d-flex gap-3 flex-wrap pb-lg-0">
                        <button
                            type="submit"
                            className="btn btn-success font-weight-bolder font-size-h6 px-8 py-4 my-3 flex-grow-1 d-flex align-items-center justify-content-center"
                            onClick={() => {
                                if (isMobileApp) {
                                    window.open('https://api.evglobal.vn/download_app', '_blank');
                                } else {
                                    Utils.openInCurrentTab(isMaintainerApp ? AppRoute.maintainerAuth : AppRoute.auth);
                                }
                            }}
                        >
                            {isMobileApp ? 'Cài đặt ứng dụng' : 'Đăng nhập tài khoản'}
                        </button>
                    </div>
                )}

                <div className="d-flex flex-column align-items-center">
                    <div
                        className="font-weight-bolder mb-2 mt-7"
                        style={{ fontSize: Utils.returnFontSize(16), color: AppColors.gray[800] }}
                    >
                        Chúng tôi đã có mặt trên các nền tảng
                    </div>
                    <div className="d-flex gap-3">
                        <a href={isMobileApp ? "https://api.evglobal.vn/download_app" : "#"} target={isMobileApp ? "_blank" : "_self"} rel="noopener noreferrer">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                                alt="Get it on Google Play"
                                style={{ height: '40px' }}
                            />
                        </a>
                        <a href={isMobileApp ? "https://api.evglobal.vn/download_app" : "#"} target={isMobileApp ? "_blank" : "_self"} rel="noopener noreferrer">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                                alt="Download on the App Store"
                                style={{ height: '40px' }}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

export default ActivateAccountResultForm;